<template>
  <div class="circle-loader-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-22 -22 44 44"
      preserveAspectRatio="xMidYMid"
      width="50"
      height="50"
      style="shape-rendering: auto; display: block; background: transparent;"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <circle
        stroke-dasharray="94.24777960769379 33.41592653589793"
        r="20"
        stroke-width="2"
        stroke="#77c8f1"
        fill="none"
        cx="0"
        cy="0"
      >
        <animateTransform
          keyTimes="0;1"
          values="0 0 0;360 0 0"
          dur="1s"
          repeatCount="indefinite"
          type="rotate"
          attributeName="transform"
        ></animateTransform>
      </circle>
    </svg>
    <div>
      <p class="circle-loader-text">{{ label || "Loading" }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['label'],
};
</script>

<style scoped>
.circle-loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.circle-loader-text {
  margin-top: 16px;
  text-align: center;
}
</style>
